import React from 'react'
import { StyledSpinner } from './Spinner.styles'

const Spinner: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { size?: string }
> = ({ color, size, ...rest }) => (
  <StyledSpinner color={color} size={size} data-testid="spinner" {...rest} />
)

export default Spinner
